<div class="p-fluid">
  <crm-checklist-period-form
    [(startAt)]="info.startAt"
    [(endAt)]="info.endAt"
    [errors]="errors"
    [canDelete]="canDelete"
    [isExtendTime]="isExtendTime"
    [isDisabledStart]="isExtendTime"
    appendTo="body"
    [class]="isError ? 'ng-invalid ng-dirty' : ''"
    (startAtChange)="checkDeadlineError()"></crm-checklist-period-form>
  <small
    *ngIf="isError"
    class="p-error inline-block mb-3"
    >{{ isError }}</small
  >

  <div class="field">
    <label class="font-medium">{{ isExtendTime ? 'Причина' : 'Комментарий' }}</label>
    <crm-editor
      [(value)]="info.reason"
      height="110px"></crm-editor>
    <small
      *ngIf="errors?.reason"
      class="p-error">
      {{ errors.reason | join }}
    </small>
  </div>
</div>

<div class="mt-3">
  <button
    pButton
    [label]="saveButtonLabel"
    class="p-button-success"
    (click)="onSave(info)"></button>
</div>
